module.exports = __webpack_public_path__ + "fe959dfd4993fe11df2125792378f730.png";